import { useState, useEffect, useCallback } from 'react';
import type { ModalityProgressCard } from '../../../types';
import { cohortsApi } from '../../../services/api/cohorts';

interface UseModalityProgressOptions {
  cohortId: string;
  enabled?: boolean;
}

interface UseModalityProgressResult {
  cards: ModalityProgressCard[];
  loading: boolean;
  error: string | null;
}

export function useModalityProgress({
  cohortId,
  enabled = true,
}: UseModalityProgressOptions): UseModalityProgressResult {
  const [cards, setCards] = useState<ModalityProgressCard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProgress = useCallback(async () => {
    if (!cohortId) return;
    try {
      setLoading(true);
      setError(null);
      const data = await cohortsApi.getModalityProgress(cohortId);
      setCards(data);
    } catch (err) {
      console.error('Failed to fetch modality progress:', err);
      setError('Failed to load modality progress');
    } finally {
      setLoading(false);
    }
  }, [cohortId]);

  useEffect(() => {
    if (enabled) {
      fetchProgress();
    }
  }, [enabled, fetchProgress]);

  return { cards, loading, error };
}
